/*!
 * bem v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { flatten } from 'ramda';

var NAMESPACE = '';
var ELEMENT_DELIMITER = '__';
var MODIFIER_DELIMITER = '--';
var VALUE_DELIMITER = '_';
var STATE_PREFIX = 'is-';

var isArray = Array.isArray;
var isString = function isString(value) {
  return toString.call(value) === '[object String]';
};
var toArray = function toArray(value) {
  return isArray(value) ? value : [value];
};
function preparePairs(pairs) {
  return Object.keys(pairs || {}).reduce(function (acc, key) {
    flatten(toArray(pairs[key]), Infinity).filter(function (value) {
      return value;
    }).forEach(function (value) {
      return acc.push(value === true ? [key] : [key, value]);
    });
    return acc;
  }, []);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function generateModifierClassNames(className) {
  var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var m = arguments.length > 2 ? arguments[2] : undefined;
  var v = arguments.length > 3 ? arguments[3] : undefined;
  var prepared = preparePairs(modifiers).map(function (modifier) {
    return modifier.join(v);
  });
  var prefix = "".concat(className).concat(m);
  return prepared.map(function (modifier) {
    return prefix + modifier;
  });
}
function generateElementClassName(block) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var e = arguments.length > 3 ? arguments[3] : undefined;
  var stack = [(!n ? '' : n) + block];

  if (element) {
    stack.push(element);
  }

  return stack.join(e);
}
function generateClassNames(block) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref = arguments.length > 3 ? arguments[3] : undefined,
      n = _ref.n,
      e = _ref.e,
      m = _ref.m,
      v = _ref.v;

  var className = generateElementClassName(block, element, n, e);
  var modifierClassNames = generateModifierClassNames(className, modifiers, m, v);
  return [className].concat(modifierClassNames);
}
var BlockGenerator =
/*#__PURE__*/
function () {
  function BlockGenerator() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$n = _ref2.n,
        n = _ref2$n === void 0 ? NAMESPACE : _ref2$n,
        _ref2$e = _ref2.e,
        e = _ref2$e === void 0 ? ELEMENT_DELIMITER : _ref2$e,
        _ref2$m = _ref2.m,
        m = _ref2$m === void 0 ? MODIFIER_DELIMITER : _ref2$m,
        _ref2$v = _ref2.v,
        v = _ref2$v === void 0 ? VALUE_DELIMITER : _ref2$v;

    _classCallCheck(this, BlockGenerator);

    this.config = {
      n: n,
      e: e,
      m: m,
      v: v
    };
  }

  _createClass(BlockGenerator, [{
    key: "block",
    value: function block(_block, element) {
      var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return generateClassNames(_block, element, modifiers, this.config);
    }
  }]);

  return BlockGenerator;
}();
function createBlockNameGenerator(config) {
  var generator = new BlockGenerator(config);
  return function (block, eom, modifiers) {
    return generator.block(block, isString(eom) ? eom : undefined, modifiers || !isString(eom) && eom || {});
  };
}
function createBlockGenerator(config) {
  var generator = createBlockNameGenerator(config);
  return function (block, element) {
    return function (eom, modifiers) {
      return generator(block, isString(eom) ? eom : element, modifiers || !isString(eom) && eom || {});
    };
  };
}

var StateGenerator =
/*#__PURE__*/
function () {
  function StateGenerator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$sp = _ref.sp,
        sp = _ref$sp === void 0 ? STATE_PREFIX : _ref$sp,
        _ref$v = _ref.v,
        v = _ref$v === void 0 ? VALUE_DELIMITER : _ref$v;

    _classCallCheck(this, StateGenerator);

    this.config = {
      sp: sp,
      v: v
    };
  }

  _createClass(StateGenerator, [{
    key: "states",
    value: function states() {
      var _states = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return generateModifierClassNames(this.config.sp, _states, '', this.config.v);
    }
  }]);

  return StateGenerator;
}();
function createStateGenerator(config) {
  var generator = new StateGenerator(config);
  return generator.states.bind(generator);
}

export { BlockGenerator, ELEMENT_DELIMITER, MODIFIER_DELIMITER, NAMESPACE, STATE_PREFIX, StateGenerator, VALUE_DELIMITER, createBlockGenerator, createBlockNameGenerator, createStateGenerator, generateClassNames, generateElementClassName, generateModifierClassNames, isArray, isString, preparePairs, toArray };



// WEBPACK FOOTER //
// ./node_modules/@aspectus/bem/dist/bem.esm.js